import React, { useEffect } from 'react';
import Myorder from '../../components/employees/Myorder';

const MyordergPage = () => {
  useEffect(() => {
      document.body.id = "myoder-004";
    }, []);
  
  return (
    <div className='commom-001'>
      <Myorder />
    </div>
  );
};

export default MyordergPage; 
